<template>
  <div id="IntegratedModelView" class="full-page-with-header">
    <gjw-space-header class="page-header">
      <template #customContent>
        <span class="breadcrumb">
          <span class="name-click" @click.stop="toPage('IntegratedModelList')">全部合模</span>
          <span class="mg-lt-sm mg-rt-sm"> > </span>
          <img class="file-img" src="../../../assets/file/model.png" style="margin-right: 6px;" alt="" />
          <span> {{ modelName }}</span>
        </span>
        <div class="mg-sm-button">
          <el-button size="mini" @click="showDetail">详情</el-button>
          <el-button size="mini" @click="toShare">分享</el-button>
        </div>
      </template>
    </gjw-space-header>
    <bimface
        :show-error="tokenError"
        :view-token="viewToken"
        :file-id="modelId"
        from="INTEGRATED_MODEL"
        file-type="INTEGRATED_MODEL"
        height="100%"
        width="100%"
    />
    <integrated-model-detail ref="integratedModelDetail" :space-id="spaceId" />
    <!-- 分享合模方案 -->
    <model-share-dialog ref="ModelShareDialog" share-type="INTEGRATED_MODEL" @share-link-opened='shareTrack' />
  </div>
</template>

<script>
import GjwSpaceHeader from '@/components/business/GjwSpaceHeader.vue'
import { mapGetters, mapMutations } from 'vuex'
import Bimface from '@/components/common/Bimface.vue'
import Config from '@/config'
import ModelShareDialog from '@/views/file/components/ModelShareDialog.vue'
import IntegratedModelDetail from '@/views/file/components/IntegratedModelDetail.vue'

export default {
  name: 'IntegratedModelView',
  components: { IntegratedModelDetail, ModelShareDialog, Bimface, GjwSpaceHeader },
  data() {
    return {
      spaceId: this.$route.params.spaceId,
      modelId: this.$route.query.id,
      modelName: this.$route.query.title,
      viewToken: '',
      tokenError: false,
    }
  },
  computed: {
    ...mapGetters({
      federationPlanFileItems: 'fileModel/federationPlanFileItems',
      federationSuccessViewTokens: 'fileModel/federationSuccessViewTokens',
      federationFailFiles: 'fileModel/federationFailFiles',
    }),
  },
  created() {
    this.getViewTokens()
  },
  mounted() {
    if (this.$route.name === 'IntegratedModelView') {
      document.title = this.$route.query.title || Config.projectName
    }
  },
  methods: {
    ...mapMutations({
      setFederationPlanFileItems: 'fileModel/setFederationPlanFileItems',
    }),
    // 根据model获取viewTokens
    async getViewTokens() {
      try {
        const data = await this.$api.file.integratedModelInfo(this.spaceId, this.modelId)
        this.modelName = data.name
        this.viewToken = data.viewToken
      } catch (e) {
        this.tokenError = true
      }
    },
    toPage(routeName) {
      this.$router.replace({ name: routeName })
    },
    // 展示详情抽屉
    showDetail() {
      this.$refs.integratedModelDetail?.openDrawer({ id: this.modelId })
      this.$tracks({
        event: 'viewIntegratedModelDetail',
        params: {
          g_c_space_id: this.spaceId,
          g_c_integrated_model_id: this.modelId,
        }
      })
    },
    // 去分享
    toShare() {
      this.$refs.ModelShareDialog?.openDialog({ id: this.modelId, name: this.modelName })
    },
    shareTrack(shareModelFileInfo) {
      this.$tracks({
        event: 'shareIntegratedModel',
        params: {
          g_c_space_id: this.spaceId,
          g_c_integrated_model_id: shareModelFileInfo.id,
        }
      })
    },
  },
}
</script>

<style lang="less" scoped>
.breadcrumb {
  display: flex;
  flex-direction: row;
  margin-right: 10px;
  font-size: 1rem;
  font-weight: normal;
  line-height: 22px;
  color: #495f70;
  .name-click{
    cursor: pointer;
    &:hover{
      color: @theme-color;
    }
  }
  .grey-text{
    color: rgba(73, 95, 112, 0.4);
  }
}
.error-bg{
  background: url("~@/assets/img/login-bg.png") no-repeat center center;
  background-size: cover;
  display: flex;
  justify-content: center;
  align-items: center;
}
.error-box {
  width: 600px;
  height: 500px;
  background: @color-fill-white;
  box-shadow: 0 4px 10px 0 rgba(0, 0, 0, 0.2);
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  .warning-text {
    font-size: 16px;
    line-height: 32px;
    color: @text-tag-gery;
  }
}
</style>
